'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOverlays = require('react-overlays');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0, bottom: 0, left: 0, right: 0,
  width: '100%',
  height: '100%'
};

var backdropStyle = _extends({}, modalStyle, {
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.7
});

var dialogStyle = {
  position: 'absolute',
  top: '50%', left: '50%',
  transform: 'translate(-50%, -50%)',
  border: '1px solid #e5e5e5',
  backgroundColor: '#fff',
  boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
  padding: 20
};

var PictureModal = function PictureModal(props) {
  return _react2.default.createElement(
    _reactOverlays.Modal,
    {
      'aria-labelledby': 'modal-label',
      style: modalStyle,
      backdropStyle: backdropStyle,
      show: props.shouldShowModal,
      onHide: props.onModalHide
    },
    _react2.default.createElement(
      'div',
      { style: dialogStyle },
      _react2.default.createElement('img', {
        style: { width: '100%' },
        src: props.file.preview || props.file
      })
    )
  );
};

PictureModal.propTypes = {
  shouldShowModal: _propTypes2.default.bool.isRequired,
  file: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
  onModalHide: _propTypes2.default.func.isRequired
};

exports.default = PictureModal;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/PictureModal.js
// module id = 163
// module chunks = 0